// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { ensurePdfjs } from "@/shared/utils/pdfjs";
import { TalentPoolPdfPage } from "@/features/talent-pool/components/TalentPoolPdfPage";
export function TalentPoolPdfViewer({ blobUrl, dataUrl }) {
  const [pdf, setPdf] = useState(null);
  const [nPages, setNPages] = useState(0);
  const [useIframe, setUseIframe] = useState(false);
  const url = blobUrl || dataUrl;
  useEffect(() => {
    if (!url) return;
    let cancelled = false;
    /* pdf.js loads on demand; ensurePdfjs() also sets the worker URL. */
    ensurePdfjs().then((lib) => {
      if (cancelled) return;
      if (!lib || typeof lib.getDocument !== "function") {
        setUseIframe(true);
        return;
      }
      return lib.getDocument({ url }).promise.then((p) => {
        if (cancelled) return;
        setPdf(p);
        setNPages(p.numPages);
      });
    }).catch(() => {
      if (!cancelled) setUseIframe(true);
    });
    return () => { cancelled = true; };
  }, [url]);
  if (useIframe && url) {
    return <iframe title="Resume PDF" src={url} className="w-full min-h-[75vh] rounded-lg border-0 bg-white" />;
  }
  if (!pdf) {
    return (
      <div className="flex justify-center py-16">
        <div className="w-10 h-10 border-4 border-brand-200 border-t-brand-600 rounded-full animate-spin" />
      </div>
    );
  }
  return (
    <div className="overflow-y-auto hide-scrollbar max-h-[75vh] space-y-2 py-2">
      {Array.from({ length: nPages }, (_, i) => (
        <TalentPoolPdfPage key={i + 1} pdf={pdf} pageNum={i + 1} />
      ))}
    </div>
  );
}

